import { type ExportColumnDefinition, Exporter } from '../Exporter';
import { i18n } from '@/i18n';

export interface InvitationCodeExportData {
  accountId?: string;
  exhibitorName?: string;
  exhibitorEmail?: string;
  listings?: string;
  code: string;
  invitationLink?: string;
  entityId?: string;
}

export class InvitationCodeExporter extends Exporter<InvitationCodeExportData> {
  private readonly baseUrl: string;
  private readonly t: typeof i18n.global.t;

  constructor() {
    super();
    this.baseUrl = window.location.origin;
    this.t = i18n.global.t;
  }

  private getColumnDefinitions(): ExportColumnDefinition[] {
    return [
      { key: this.t('platform.export.header.accountId'), width: 15 },
      { key: this.t('platform.export.header.exhibitorName'), width: 20 },
      { key: this.t('platform.export.header.exhibitorEmail'), width: 30 },
      { key: this.t('platform.export.header.listings'), width: 10 },
      { key: this.t('platform.export.header.invitationCode'), width: 15 },
      { key: this.t('platform.export.header.invitationLink'), width: 50 },
    ];
  }

  protected getColumnsToExport(): ExportColumnDefinition[] {
    return this.getColumnDefinitions();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected formatData(data: InvitationCodeExportData[]): Record<string, any>[] {
    const columns = this.getColumnDefinitions();
    return data.map((item) => ({
      [columns[0].key]: item.accountId || '',
      [columns[1].key]: item.exhibitorName || '',
      [columns[2].key]: item.exhibitorEmail || '',
      [columns[3].key]: item.listings || '',
      [columns[4].key]: item.code || '',
      [columns[5].key]:
        item.invitationLink ||
        (item.code ? `${this.baseUrl}/invite/${item.code}${item.entityId ? '?entityId=' + item.entityId : ''}` : ''),
    }));
  }

  public exportCodes(codes: string[], entityId: string): void {
    const data = codes.map((code) => ({ code, entityId }));
    const filename = this.generateTimestampFilename('invitations');
    this.export(data, filename);
  }
}
